import TagIcon from '@mui/icons-material/LocalOffer';

import Tags from "./TagsPage";

const exports = {
    Page: Tags,
    Icon: TagIcon
};
export default exports;
